export enum Routes {
  Landing = '/',
  SignIn = '/sign-in',
  SignUp = '/sign-up',
  RecoverPassword = '/recover',
  ResetPassword = '/reset-password',
  Dashboard = '/dashboard',
  SupplierStats = '/supplier-stats',
  ContactUs = '/contact-us',
  Performance = '/performance',
  Settings = '/settings',
  Transactions = '/supplier-transactions',
  SupplierSettings = '/supplier-settings',
  Payouts = '/payouts',
  VerifyEmail = '/verify-email',
  PageNotFound = '*',
  ErrorPage = '/500',
  PrivacyPolicy = '/privacy-policy',
  TermsOfUse = '/terms-of-use',
  Commitment = '/return_from_study',
  Profilers = '/survey',
  SurveyStatus = '/survey_status',
  Onboarding = '/welcome',
  Supplier = '/begin',
  SupplierTerms = '/supplier-terms',
  Wall = '/wall',
  VerisoulFaceCheckRedirect = '/verisoul/face-check-redirect',
}

export enum APIRoutes {
  TrackVS = '/api/track/vs/',
  LogIn = '/api/login/',
  LogOut = '/api/logout/',
  SingUp = '/api/signup/',
  ResetPasswordInitiate = '/api/reset_password/initiate/',
  ResetPasswordSubmit = '/api/reset_password/submit/',
  RefreshTokens = '/api/refresh_tokens/',

  UserInfoBasic = '/api/user/basic/',
  UserInfoFull = '/api/user/full/',
  ChangePassword = '/api/user/password/',
  VerifyEmailInitiate = '/api/verify_email/initiate/',
  VerifyEmailSubmit = '/api/verify_email/submit/',
  UserAddress = '/api/user/address/',
  UserPhone = '/api/user/phone/',
  DeleteAccount = '/api/user/',
  Preferences = '/api/user/preferences/',
  ContactUs = '/api/contact_us/',
  Countries = '/api/countries/',

  PayoutsHistory = '/api/user/payouts/',
  CreatePayout = '/api/payout/',
  PayoutMethods = '/api/user/payout_methods/',
  PayoutHandlers = '/api/user/payout_handlers/',
  SupportedPayoutMethods = '/api/payout/supported_methods/',
  ConnectPaypal = '/api/paypal/connect/',
  DisconnectPaypal = '/api/paypal/',

  SurveysHistory = '/api/user/commitments/',
  CommitmentInitiate = '/api/commitment/initiate/',
  CommitmentNext = '/api/commitment/next_action/',
  CommitmentOptions = '/api/commitment/options/',
  CommitmentResult = '/api/attempt/outcome/',
  CommitmentSubmitAnswer = '/api/commitment/submit_answer_and_next_action/',
  CommitmentSubmitFeedback = '/api/commitment/submit_feedback/',
  CommitmentInitiateSpecial = '/api/commitment/initiate_special/',
  CommitmentSubmitAnswerAndNextAction = '/api/commitment/submit_attempt_outcome_and_next_action/',
  CommitmentLoginFromOutcome = '/api/commitment/login_from_outcome/',
  CommitmentSkipAnswerAndNextAction = '/api/commitment/skip_answer_and_next_action/',
  CommitmentSpinAndNextAction = '/api/commitment/spin_and_next_action/',
  CommitmentCurrentState = '/api/commitment/current_state/',
  CommitmentPauseProfilerDecisionAndNextAction = '/api/commitment/pause_profiler_decision_and_next_action/',
  CommitmentAbandonStudyAndNextAction = '/api/commitment/abandon_study_and_next_action/',
  CommitmentVerisoulFaceCheckOutcome = '/api/commitment/verisoul_face_check_outcome/',
  CommitmentVerisoulFaceCheck = '/api/commitment/verisoul_face_check_entry/',
  ReportVideoWatched = '/api/commitment/report_video_watched/',
  SupplierIframeSettings = '/api/supplier_dashboard/iframe_settings/',

  SupplierLogIn = '/api/supplier/login_and_commitment/',
  SupplierSignUp = '/api/supplier/signup_and_commitment/',

  SupplierStats = '/api/supplier_dashboard/stats/',
  SupplierTransactions = '/api/supplier_dashboard/commitments/',
  SupplierUrls = '/api/supplier_dashboard/urls/',
  SupplierSupplierSendDummyPostback = '/api/supplier_dashboard/supplier_send_dummy_postback/',

  AffiliateTrackEvent = '/api/track/event/',

  OnboardingState = '/api/user/state/',

  ResearchDefenderToken = '/api/track/meta/',
  Wall = '/api/wall/',

  OutcomeFilterOptions = '/api/supplier_dashboard/reference-data/',

  // TODO: remove
  TEMP_ResetOnboardingState = '/api/user/state/reset/',
  TEMP_AdvanceOnboardingState = '/api/user/state/next/',
  TEMP_CommitmentDummyData = '/api/dummy_data/',
  TEMP_Profiler_Data = '/api/get_profiler/',
  ProfilerLocalization = '/api/profiler/get_localization/',
}
